export class ShipmentActionUpdateAddress {
    public addressLine1: string
    public addressLine2: string
    public city: string
    public stateProvince: string
    public postalCode: string
    public country: string
    public rowVersion: string
    public latitude: number | null = null;
    public longitude: number | null = null;
    public timeZoneId: string = '';
    public force: boolean = false;
}